import { type INotification } from '@/types/INotification';
import { isRecord } from './isRecord';
import { isSocketOrderEvent } from './isSocketOrderEvent';

/**
 * Type guard формы уведомления. Сверяет базовые поля и валидирует `payload`
 * по дискриминатору `type`. Используется при чтении истории уведомлений из
 * localStorage, чтобы безопасно сузить `unknown` без приведения типов.
 *
 * @param value - произвольное значение (распарсенный JSON)
 * @returns `true`, если значение соответствует форме `INotification`
 */
export const isNotification = (value: unknown): value is INotification => {
  if (
    !isRecord(value) ||
    typeof value.id !== 'string' ||
    typeof value.createdAt !== 'number' ||
    typeof value.isRead !== 'boolean'
  ) {
    return false;
  }

  if (value.type === 'order') {
    return isSocketOrderEvent(value.payload);
  }

  return false;
};
